export default __webpack_public_path__ + "static/media/TV - 1.106b2bb0.png";